import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateGroupsActions } from "store/ducks/settings/groups";

export function* paginateGroupsRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/groups?${queryString}`
    );

    const { groups, pagination } = responseBody;
    yield put(PaginateGroupsActions.success(groups, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateGroupsActions.failure(errorMessage));
  }
}
